import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

export const onDatalayer = ({ target }: OnDatalayerProps) => {
  const href = target?.href || '';
  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;

  return {
    event: 'clickBreadcrumb',
    eventCategory: 'Breadcrumb',
    href,
    ...(variantName && { variant_name: variantName }),
  };
};
